import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonContactRequestGridPart } from '../../../../../ui/widget';
import { ExperienceEngagementsService } from '../../experience-engagements.service';

@Component({
	selector: 'experience-contact-request-view-part',
	standalone: true,
	imports: [CommonContactRequestGridPart],
	templateUrl: './contact-request-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./contact-request-view.part.scss'],
})
export class ExperienceContactReqFollowUpsViewPart {
	public readonly pageService = inject(ExperienceEngagementsService);
	public contactRequests = computed(() => (this.pageService.contactRequests() || []));
}